import React, { useEffect, useMemo, useState } from 'react';
import { changeHeaderStyle, changeHeaderText } from 'app/actions/headerActions';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { ContentAdDesktop } from 'app/styles/content';
import { Helmet } from 'react-helmet-async';
import { TITLE_POSTFIX } from 'app/seo/seo.constants';
import { List, ListItem, ListItemSecondaryAction, ListItemText, ListSubheader, Switch } from '@mui/material';
import { SIZES } from '@fupa/fupa-uikit';
import ExperimentalFeatureManager from 'app/models/experimentalFeature/ExperimentalFeatureManager';
const ContentTotal = styled(ContentAdDesktop).withConfig({
  componentId: "sc-1yq2qna-0"
})(["&&&{height:75vh;padding:0 ", ";}"], SIZES['16']);
const ExperimentalPage = () => {
  const dispatch = useDispatch();
  const features = ExperimentalFeatureManager.availableFeatures;
  const meta = [{
    name: 'description',
    content: "Experimentelle Funktionen zum Testen von Funktionen, die noch nicht ver\xF6ffentlicht sind."
  }, {
    name: 'robots',
    content: 'noindex, follow'
  }];
  useEffect(() => {
    dispatch(changeHeaderStyle({
      size: 'small'
    }));
    dispatch(changeHeaderText({
      title: 'Experimentelle Funktionen'
    }));
  }, [dispatch]);
  return /*#__PURE__*/React.createElement(ContentTotal, {
    noTabs: true,
    top: "4.5rem",
    "data-sentry-element": "ContentTotal",
    "data-sentry-component": "ExperimentalPage",
    "data-sentry-source-file": "ExperimentalPage.tsx"
  }, /*#__PURE__*/React.createElement(Helmet, {
    title: "Experimentelle Funktionen'".concat(TITLE_POSTFIX),
    meta: meta,
    "data-sentry-element": "Helmet",
    "data-sentry-source-file": "ExperimentalPage.tsx"
  }), /*#__PURE__*/React.createElement(List, {
    subheader: /*#__PURE__*/React.createElement(ListSubheader, null, "Darstellung"),
    sx: theme => ({
      width: '100%',
      maxWidth: '640',
      backgroundColor: theme.palette.background.paper
    }),
    "data-sentry-element": "List",
    "data-sentry-source-file": "ExperimentalPage.tsx"
  }, features.map(feature => /*#__PURE__*/React.createElement(Feature, {
    feature: feature,
    key: feature.getSlug()
  }))));
};
export const Feature = _ref => {
  let {
    feature
  } = _ref;
  const [isActive, setIsActive] = useState(ExperimentalFeatureManager.getInstance().isEnabled(feature));
  const itemId = useMemo(() => feature.getSlug(), [feature]);
  const handleChange = (event, value) => {
    if (value) {
      setIsActive(true);
      ExperimentalFeatureManager.getInstance().enable(feature);
    } else {
      setIsActive(false);
      ExperimentalFeatureManager.getInstance().disable(feature);
    }
  };
  return /*#__PURE__*/React.createElement(ListItem, {
    "data-sentry-element": "ListItem",
    "data-sentry-component": "Feature",
    "data-sentry-source-file": "ExperimentalPage.tsx"
  }, /*#__PURE__*/React.createElement(ListItemText, {
    id: itemId,
    primary: feature.getLabel(),
    "data-sentry-element": "ListItemText",
    "data-sentry-source-file": "ExperimentalPage.tsx"
  }), /*#__PURE__*/React.createElement(ListItemSecondaryAction, {
    "data-sentry-element": "ListItemSecondaryAction",
    "data-sentry-source-file": "ExperimentalPage.tsx"
  }, /*#__PURE__*/React.createElement(Switch, {
    edge: "end",
    onChange: handleChange,
    checked: isActive,
    inputProps: {
      'aria-labelledby': itemId
    },
    "data-sentry-element": "Switch",
    "data-sentry-source-file": "ExperimentalPage.tsx"
  })));
};
export default ExperimentalPage;